module.exports = __webpack_public_path__ + "img/type_right_2.93ec8494.png";